import Paper, { PaperProps } from '@mui/material/Paper'
import { createElement, forwardRef } from 'react'

import { foundationTokens } from '../../../foundations'

export type PanelProps = PaperProps

export const Panel = forwardRef<HTMLDivElement, PanelProps>(
  ({ elevation = foundationTokens.shadow.surface, sx, ...props }, ref) =>
    createElement(Paper, {
      ref,
      elevation,
      sx: [
        theme => ({
          width: '100%',
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: `${foundationTokens.radius.surface}px`
        }),
        ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
      ],
      ...props
    })
)

Panel.displayName = 'Panel'
